export default __webpack_public_path__ + "static/media/17 - Mountain.894db5f9.jpeg";